<cp-auth-page-common>

  <div class="AuthPageControlsContainer"
       (keyup.enter)="onSendResetRequest()">

    <div class="AuthPageControlsHeader">
      {{ 'DESIGN_B.FORGOT_PASSWORD.RESET_PASSWORD' | translate }}
    </div>

    <div class="AuthPageControlsLabel">
      {{ 'DESIGN_B.USER_LOGIN.LOGIN_NAME' | translate }}
    </div>

    <div class="EmailLoginInputContainer">
      <cp-form-input
        [form]="formGroup"
        [controlName]="EMAIL_OR_LOGIN_NAME"
        [valueType]="ValueType.TEXT"
        [renderNameProperty]="'login'"
        [placeholder]="null"
        [type]="InputTagType.INPUT">
      </cp-form-input>
    </div>

    <hr>

    <div class="AuthPageControlsFooter">
      <cp-inline-button [size]="ButtonSize.SMALL"
                        [text]="'DESIGN_B.FORGOT_PASSWORD.BACK_TO_LOGIN' | translate"
                        [disabled]="inProgress"
                        (buttonClick)="onBackToLogin()">
      </cp-inline-button>
      <cp-button [size]="ButtonSize.MEDIUM"
                 [disabled]="formGroup.invalid || inProgress || showRequestSentMessage"
                 [text]="'DESIGN_B.FORGOT_PASSWORD.REQUEST_RESET' | translate"
                 [showSpinner]="inProgress"
                 (buttonClick)="onSendResetRequest()">
      </cp-button>
    </div>

  </div>

  <div class="AuthPageAlertMessageContainer">
    <cp-message-design-b-small
      [(visible)]="showRequestSentMessage"
      [severity]="MessageSeverity.SUCCESS"
      [messageText]="'DESIGN_B.FORGOT_PASSWORD.REQUEST_SENT_HINT' | translate">
    </cp-message-design-b-small>
  </div>

</cp-auth-page-common>
